import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { StyledButton, StyledCancelButton } from '../component/StyledComponent';

export default function StatusDialog({ open, setOpen,onSubmit,status,name }) {

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    return (
        <React.Fragment>
            <Dialog
                open={open}
                fullWidth
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title" sx={{textTransform:'capitalize', fontWeight:'bold'}}>
                {status==='active'? 'inactive':'active'} {name}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure want to {status==='active'? 'inactive':'active'} this {name}?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <StyledCancelButton onClick={handleClose} variant="outlined">Cancel</StyledCancelButton>
                    <StyledButton onClick={onSubmit} autoFocus>
                    {status==='active'? 'inactive':'active'}
                    </StyledButton>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
